import * as yup from 'yup'

export const getAssetClassValidationSchema = () => {
  return yup.object({
    name: yup.string().required('Name is required'),
    assetCategoryId: yup.number().required('Asset category is required'),
  })
}
